import { useEffect, useState } from 'react';
import Modal from '../../common/ModalPopup';
import { toast } from 'react-toastify';
import { addInsurer,editInsurer} from '../../store/slices/Insurer';
import * as HELPER from '../../config/helper';
import { PAGE_NUMBER, ROLE_FEATURES, STATUS_SUCCESS } from '@src/config/constant';
import ReactSelect from '@common/ReactSelect';
import { useLanguage } from '@src/context/LanguageContext';


type SelectedInputType = {
    name:string,
    partner_id: any,
    admin_fee:string,
    logo:File
}


type ApiParamsType = {
    name: string,
    partner_id: number[],
    admin_fee: string
}


export default function AdeEditInsurer(props: any): ReturnType<React.FC> {
    let { partnerListDropDown, showAddInsPartnerIcon, handleModalClose, callFrom,fetchPartnerMappings } = props; 
    let [selectedInput, setSelectedInput] = useState<any>({ name:'',partner_id:'',admin_fee:''})
    let [logo, setLogo] = useState<File>()
    let [previewImageLogo, setPreviewImageLogo] = useState<string>("images/upload_icn.svg")
    let [errors, setErrors] = useState<any>({})
    const { translations } = useLanguage();
    

    useEffect(()=>{ 
        setInputFields(props.selectedPartner)
        // eslint-disable-next-line
    }, [props])
  
     
    const handleChange = (name: string, value: any, index?: number) => {
        let newState = { 
            [name]: (name !== 'partner_id') ? value.target.value : value?.value,
        };
        if(name ==='partner_id' && props.selectedPartner?.partner_list){
            newState.admin_fee = props.selectedPartner?.partner_list.filter((key: any) => key.value === value?.value)[0]?.admin_fee;
        }  
        setSelectedInput((prev: any) => ({
            ...prev,
            ...newState
        }));  
         
        setErrors((prevErrors:any) => ({
        ...prevErrors,
        [name]: value ? "" : prevErrors[name], // Clear error if value exists
      }));
    }
    // main modal close Xs
    const handleClose = () => {
        handleModalClose()
        setLogo(undefined)
        setPreviewImageLogo("images/upload_icn.svg")
        setSelectedInput({
          name:'',partner_id:'',admin_fee:'',file:'',logo:''
        })
        setErrors({})
        setInputFields({})
        
    }
 
    const checkValidation = (): boolean => {
        let error = false
        setErrors({}) 
        for (let key in selectedInput) {
            let keytype = typeof (selectedInput[key as keyof SelectedInputType])
            if(selectedInput[key])
            if (keytype === 'object' && !Object.keys(selectedInput[key as keyof SelectedInputType]).length && key!=='logo') {
                setErrors((prev: any) => {
                    return {
                        ...prev,
                        [key]: true
                    }
                })
                error = true
            }
            if (keytype === 'object' && key ==='logo' && !logo) {
                setErrors((prev: any) => {
                    return {
                        ...prev,
                        [key]: true
                    }
                })
                error = true
            }

            if (keytype === 'object' && Array.isArray(selectedInput[key]) && !selectedInput[key]?.length) {
                setErrors((prev: any) => {
                    return {
                        ...prev,
                        [key]: true
                    }
                })
                error = true
            }

            if (keytype === 'string' && !selectedInput[key as keyof SelectedInputType] && key!=='file') {
                setErrors((prev: any) => {
                    return {
                        ...prev,
                        [key]: true
                    }
                })
                error = true
            }
            
        }
        if (callFrom && callFrom === 'AddInsurer' && !logo) {
            setErrors((prev: any) => {
                return {
                    ...prev,
                    file: true
                }
            })
            error = true
        }
        return error
    }
 
    const handleFileInputChange = async (e: any) => {
        let selectedFile = e.target.files[0]
        if (selectedFile) {
            let base64PreviewImg: any = await HELPER.toBase64(selectedFile)
            let filetype = await HELPER.detectMimeType(base64PreviewImg)
            let fileSize = selectedFile.size
            if (!filetype) {
                toast.error(translations.Insurer?.['Please Select A Valid File'] || translations.commonMsg?.loading)
                e.target.value = ''
                return
            }

            else if (fileSize < 25000 || fileSize > 5000000) {
                toast.error(translations.Insurer?.['file size should be between 25kb to 5mb'] || translations.commonMsg?.loading)
                e.target.value = ''
                return
            }
            setLogo(selectedFile)
            setSelectedInput((prev: any) => ({
                ...prev,
               logo:selectedFile
            })); 
            if(selectedFile){
                setErrors((prev: any) => ({
                    ...prev,
                   logo:'',
                   file:''
                })); 
                setPreviewImageLogo(base64PreviewImg)
            }
        }

    }

    /**
     * function to submit api reques
     *  validates request and calls service according to callFrom flag
     */
    const handleSubmit = async () => {
        let errorExists = checkValidation()
         //if validation error
        if (errorExists) {
            // toast error message because when bank detail not expand in that case it will show
            toast.error(translations.Insurer?.['Please ensure all details are completed'] || translations.commonMsg?.loading)
            return
        }
        //preparing form data
        let formData = new FormData()
        let apiParams: any = {
            name: selectedInput.name,
            partner_id: selectedInput.partner_id,
            admin_fee: selectedInput?.admin_fee,
        }

        for (let key in apiParams) {
            let value = apiParams[key as keyof ApiParamsType]
            if (typeof (value) == 'object') {
                formData.append(key, JSON.stringify(value))
            }
            else {
                formData.append(key, value)
            }
        }
        let saveResponse: any;
        let savePartnerMsg: string = "";
        if (callFrom && callFrom === 'AddInsurer') {
            props.handleLoader(true)
            if (logo) formData.append('logo', logo)
            saveResponse = await addInsurer(formData)
            savePartnerMsg = saveResponse.message;
        }

        else if ((callFrom && callFrom === 'EditInsurer')) {
            
            props.handleLoader(true) 
            formData.append('insurer_id',props.selectedPartner.id)
            if (logo) formData.append('logo', logo)
            saveResponse = await editInsurer(formData)
            savePartnerMsg = saveResponse.message

        }
        if (saveResponse.status===STATUS_SUCCESS) {
            fetchPartnerMappings({page_number: PAGE_NUMBER})
            handleClose();
            toast.success(savePartnerMsg)
        }else{
            props.handleLoader(false)
            toast.error(savePartnerMsg)
        }
    }

    /**
     * Function to auto fill input fields in edit mode based on selected Partner
     * @param selectedPartner 
     */
    const setInputFields = (record: any) => {
        if(callFrom==='EditInsurer'){ 
            setSelectedInput((prev:any) => {
                return {
                    ...prev,
                    name:record.name,
                    partner_id: props.selectedPartner?.partner_list?.[0]?.value || 1, 
                    admin_fee:   props.selectedPartner?.partner_list?.[0]?.admin_fee || 0, 
                    logo:record.logo
                }
            })
        }
    }
    const removeImage = () => { 
        setSelectedInput((prev:any) => ({
            ...prev,
            logo: '',
        }));
        setPreviewImageLogo("images/upload_icn.svg")
    };  
    const PARTNER_LIST  = (callFrom === 'EditInsurer')  ? props.selectedPartner?.partner_list: partnerListDropDown; 

    return (
        <div className="Add-Financer-popup bankdetail-popup">
            <Modal show={showAddInsPartnerIcon ?? false} handleClose={handleClose} >
                <div className="modal-header">

                    <h2>{!props.selectedPartner?.id ? (translations.Insurer?.['Add New Insurance Partner'] || translations.commonMsg?.loading) : (translations.Insurer?.['Edit Insurance Partner'] || translations.commonMsg?.loading)}</h2>
                </div>

                <div className="modal-body" >

                    <div className="row">
                        <div className='col-md-6'>
                            <div className='row'>
                              

                                <div className='form-select-bx col-md-12 partner-add-edit'>
                                    <ReactSelect 
                                        options={PARTNER_LIST ?? []} 
                                        value={ 
                                            PARTNER_LIST?.find((key: any) => key.value === selectedInput?.partner_id) || ''
                                        }
                                        handleChange={(e: any, fieldKey: string) => handleChange(fieldKey, e)} 
                                        placeholder={`${translations.Insurer?.['Partner Name'] || translations.commonMsg?.loading} *`} fieldKey="partner_id" 
                                        errorField={errors?.partner_id ? (translations.commonMsg?.required || translations.commonMsg?.loading) : ''} 
                                     />
                                </div>

                                <fieldset className="form-select-bx col-md-12 w-100">
                                    <div className="material">
                                        <input 
                                            id="" 
                                            type="text" 
                                            placeholder=" " 
                                            name="name" 
                                            className="form-input"  
                                            onChange={(e: any) => handleChange('name', e)} 
                                            value={selectedInput['name']} 
                                        />
                                        <label data-label={`${translations.Insurer?.['Insurance Insurer Name'] || translations.commonMsg?.loading} *`} className="form-label"></label>
                                        {
                                            errors?.name?<span className="error-txt">{translations.commonMsg?.required || translations.commonMsg?.loading}</span>:''
                                        }
                                    </div>
                                </fieldset>
                                

                                <fieldset className="form-select-bx col-md-12 w-100">
                                    <div className="material">
                                        <input 
                                            id="" 
                                            type="text" 
                                            placeholder=" " 
                                            name="admin_fee" 
                                            className="form-input"  
                                            onChange={(e: any) => handleChange('admin_fee', e)} 
                                            value={selectedInput['admin_fee']} 
                                         />
                                        <label data-label={`${translations.Insurer?.['Admin Fee'] || translations.commonMsg?.loading} *`} className="form-label"></label>
                                        {
                                            errors?.admin_fee?<span className="error-txt">{translations.commonMsg?.required || translations.commonMsg?.loading}</span>:''
                                        }
                                    </div>
                                </fieldset>

                            </div>


                        </div>
                        <div className="img-bx-select-opt col-md-6">
                            <div className="image-bx more-file-upload add-insurance-partner">
                            
                                {selectedInput['logo'] ? (
                                    <>
                                    {/* Remove Icon (Only shown when logo is present) */}
                                    <span className="close-icn" onClick={removeImage}>
                                        <i className="ic-clearclose"></i>
                                    </span>

                                    {/* Display the logo */}
                                    <img src={typeof selectedInput.logo === 'string' ? selectedInput.logo : URL.createObjectURL(selectedInput.logo)} alt="partner_logo" className="upload-icn" />
                                    
                                    </>
                                ) : (
                                    <>
                                    {/* Show Upload Icon when no logo is present */}
                                    <img src={previewImageLogo || ''} alt="uploadImage" className="upload-icn" />
                                    
                                    {/* File Upload Input */}
                                    <input
                                        type="file"
                                        name="image"
                                        id="upload-image-input"
                                        className="upload-box"
                                        accept="image/*"
                                        onChange={(e: any) => handleFileInputChange(e)}
                                    />
                                    <p>{translations.Insurer?.['Upload Photo'] || translations.commonMsg?.loading}</p>
                                    </>
                                )}

                                <label data-label="Insurance Insurer Logo *" className="form-label insurance-partner-logo">
                                {translations.Insurer?.['Insurance Insurer Logo'] || translations.commonMsg?.loading} *
                                </label>

                                {callFrom && callFrom ==='EditInsurer' ? errors?.logo && <span className="error-txt error-left">{translations.Insurer?.['Please select a file'] || translations.commonMsg?.loading}</span> :errors?.file && <span className="error-txt error-left">{translations.Insurer?.['Please select a file'] || translations.commonMsg?.loading}</span> }
                            
                            </div>

                        </div>
                    </div>                               
                    {

                        HELPER.isUserHasAccessPage({ permissionID: ROLE_FEATURES['insurance_partner_management'], accessType: 'edit' }) &&
                        <button className="btn-primary" onClick={handleSubmit}>
                           {translations.commonMsg?.save || translations.commonMsg?.loading}
                        </button>
                    }
                </div>
            </Modal>

        </div>
    )
}
